import ProfilePic1 from "../Assets/daniela.png";
import ProfilePic2 from "../Assets/simone.png";
import ProfilePic3 from "../Assets/bruno.png";
import { AiFillStar } from "react-icons/ai";

const testimonials = [
  {
    id: 1,
    name: "Simone Silva",
    text:
      "Hortaliças de excelente qualidade, mudas de hortaliças de ótima qualidade. Morango, cogumelos, tudo sem agrotóxicos. Vale a pena conferir.",
    rating: 5,
    img: ProfilePic1,
  },
  {
    id: 2,
    name: "Daniela Aparecida",
    text:
      "Sou confeiteira e tenho sempre problemas para encontrar morangos de qualidade, que durem. Os morangos da Verde Musgo são incríveis, saborosos e duram muito mais que os convencionais.",
    rating: 5,
    img: ProfilePic2,
  },
  {
    id: 3,
    name: "Bruno Costa",
    text:
      "Ótima iniciativa apoiar pequenos produtores — produtos saborosos e com muita qualidade. Atendimento carinhoso, preocupado. Entrega cuidadosa. Recomendo muito!",
    rating: 4,
    img: ProfilePic3,
  },
];

const Testimonial = () => {
  return (
    <div id="testimonial" className="work-section-wrapper">
      <div className="work-section-top">
        <p className="primary-subheading">Depoimentos</p>
        <h1 className="primary-heading">O que dizem sobre nós</h1>
        <p className="primary-text">
          Veja o feedback de clientes que provaram nossos produtos e aprovaram a
          qualidade e o atendimento.
        </p>
      </div>

      <div className="work-section-bottom">
        {testimonials.map((t) => (
          <div className="work-section-info" key={t.id}>
            <img src={t.img} alt={`${t.name} - foto do perfil`} style={{ borderRadius: '50%', maxWidth: 100, marginBottom: '1rem' }} />
            <p>{t.text}</p>
            <div className="testimonials-stars-container" style={{ marginTop: '1rem' }}>
              {Array.from({ length: t.rating }).map((_, i) => (
                <AiFillStar key={i} />
              ))}
            </div>
            <h2>{t.name}</h2>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonial;
